Postlogin = (function (my) {
    my.UserOverviewReport = {};
    const me = my.UserOverviewReport;

    me.$reportResultsTable = $('#report-results-table');
    me.reportUrl = $('#report-select').find('option[value="UserOverviewReport"]').data('report-url');
    me.exportUrl = $('#report-select').find('option[value="UserOverviewReport"]').data('report-export-url');

    me.filters = [
        'user-license-ids',
        'user-groups',
        'user-types',
        'user-grades',
        'search-user-name',
        'search-first-name',
        'search-last-name',
        'search-unique-identifier',
        'search-date',
    ];

    me.setup = function () {
        $('.filter-column').each((index, element) => {
            const thisFilter = $(element);
            if (me.filters.includes(thisFilter.data('filter-name'))) {
                thisFilter.removeClass('hide');
            } else {
                thisFilter.addClass('hide');
            }
        });

        $('.search-date')
            .find('.help-block')
            .text(
                'Limits the results for the time spent on site, login count, career journals completed, assessments completed, and videos watched.',
            );
        me.initEvents();

        me.$reportResultsTable.bootstrapTable('destroy');
        $('#report-toolbar').hide();
        $('.init-cover').hide();
    };

    me.runReport = function () {
        me.$reportResultsTable.addClass('sorting');
        $('body').css('cursor', 'progress');

        me.$reportResultsTable.bootstrapTable('destroy');
        me.$reportResultsTable.bootstrapTable(me.tableOptions);

        $('#report-toolbar').show();
    };

    me.exportReport = function () {
        const opts = $('#report-results-table').bootstrapTable('getOptions');
        const exportParams = me.getReportParams({
            columns: _.map($('#report-results-table').bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
            pageNumber: 1,
            sortName: opts.sortName,
            sortOrder: opts.sortOrder,
            browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${me.exportUrl}?${queryString}`, '_blank');
    };

    me.initEvents = function () {
        // Ported from bootstrap-select to Tom Select 2026-05-12.
        // initEvents re-runs every time the user switches to this
        // report tab, so each picker needs to be destroyed (if
        // previously initialized) before a fresh instance is made.
        // The old .val('').selectpicker({...}).selectpicker('render')
        // chain collapses into: clear native value, destroy, recreate.
        // Tom Select propagates the native change event, so callers
        // that listened for change on the backing <select> keep
        // working unchanged.
        const resetPicker = (selector, placeholder) => {
            const el = document.querySelector(selector);
            if (!el) return;
            if (el.tomselect) {
                el.tomselect.destroy();
            }
            $(el).val('');
            // eslint-disable-next-line no-new
            new TomSelect(el, {
                placeholder,
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        };

        resetPicker('#user-types', 'Any user role');
        resetPicker('#user-groups', 'Choose Group(s)');
        resetPicker('#user-groups-single', 'Choose Group');
        resetPicker('#user-grades', 'Choose Grade(s)');
    };

    me.getReportParams = function (params) {
        const reportParams = {};
        reportParams.username = $('#search-user-name').val();
        reportParams.first_name = $('#search-first-name').val();
        reportParams.last_name = $('#search-last-name').val();
        reportParams.unique_identifier = $('#search-unique-identifier').val();
        reportParams.district_id = me.$reportResultsTable.data('district-id');
        reportParams.license_ids = $.makeArray($('#user-license-ids option:selected').map((a, item) => item.value));
        reportParams.user_type = $.makeArray($('#user-types option:selected').map((a, item) => item.value));
        reportParams.group_id = $.makeArray($('#user-groups option:selected').map((a, item) => item.value));
        reportParams.grade = $.makeArray($('#user-grades option:selected').map((a, item) => item.value));
        reportParams.date = $('#search-date option:selected').val();
        reportParams.date_range_from = $('#search-start-date').val();
        reportParams.date_range_to = $('#search-end-date').val();

        if ($('#search-active option:selected').val() !== 'both') {
            reportParams.active = $('#search-active option:selected').val();
        }
        if ($('#search-logged-in option:selected').val() !== 'both') {
            reportParams.logged_in = $('#search-logged-in option:selected').val();
        }

        reportParams.columns = params.columns;
        reportParams.page = params.pageNumber;
        reportParams.page_size = params.pageSize;
        reportParams.order_by = params.sortName;
        reportParams.sort_order = params.sortOrder;

        return reportParams;
    };

    me.tableOptions = _.extend({}, Jr.reportsDataTable.options, {
        idField: 'user_id',
        url: me.reportUrl,
        sortName: 'username',
        toolbar: '#report-toolbar',
        responseHandler(res) {
            const formattedResult = {};
            formattedResult.total = res.meta.total;
            formattedResult.rows = res.data;
            formattedResult.duration = res.meta.duration;

            if ($('#search-date option:selected').val() === 'custom') {
                $('#report-results-table th.date-range-header').text(`${$('#search-start-date').val()} to ${$('#search-end-date').val()}`);
            } else {
                $('#report-results-table th.date-range-header').text($('#search-date option:selected').text());
            }

            return formattedResult;
        },

        queryParamsType: 'other',
        queryParams(params) {
            return me.getReportParams(params);
        },

        columns: [
            [
                {
                    title: 'Role',
                    field: 'role_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        let roleClass = '';

                        switch (row.role_id) {
                            case 2:
                                roleClass = 'fa-child';
                                break;
                            case 3: // teacher
                                roleClass = 'fa-user text-success';
                                break;
                            case 4: // school admin
                                roleClass = 'fa-user text-info';
                                break;
                            case 5: // district admin
                                roleClass = 'fa-user text-info';
                                break;
                            case 6: // vjs admin
                                roleClass = 'fa-user text-danger';
                                break;
                            case 7:
                                roleClass = 'fa-laptop';
                                break;
                            default:
                                break;
                        }

                        return `<i class="fa ${roleClass}" aria-hidden="true"></i>`;
                    },
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        return value != null ? `<a href="${row.userUrl}">${value}</a>` : value;
                    },
                },
                {
                    title: 'Unique ID',
                    field: 'unique_identifier',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        return value != null ? `<a href="${row.userUrl}">${value}</a>` : value;
                    },
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        return value != null ? `<a href="${row.userUrl}">${value}</a>` : value;
                    },
                },
                {
                    title: 'School',
                    field: 'license_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Grade',
                    field: 'grade',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Grad Year',
                    field: 'graduation_year',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Created',
                    field: 'date_created',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value) {
                        return value ? new Date(value).toLocaleDateString('en-us') : '-';
                    },
                },
                {
                    title: 'Last Activity',
                    field: 'date_last_activity',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    rowspan: 2,
                    formatter(value) {
                        return value ? new Date(value).toLocaleDateString('en-us') : '-';
                    },
                },
                {
                    title: 'Videos Watched',
                    field: 'videos_watched',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assessments Complete',
                    field: 'assessments_complete',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Lessons Complete',
                    field: 'lessons_complete',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Career Journals',
                    field: 'career_journals',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Logins',
                    field: 'site_visits',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Time Spent',
                    field: 'time_spent',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            [
                {
                    title: 'Date Range',
                    field: 'date_range',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    colspan: 5,
                    class: 'date-range-header',
                },
            ],
        ],
    });

    return my;
}(Postlogin));
